import styled from "styled-components";

import { Text } from "@ui/Atoms/Text";
import { NormalizedList } from "@ui/Atoms/List";

export const List = styled(NormalizedList)`
  padding-top: ${props => props.theme.spacing.spacing_16};
  color: ${props => props.theme.palette.white};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.spacing_8};

  ${props => props.theme.breakpointsV2.largeMobile} {
    padding-top: calc(
      ${props => props.theme.spacing.spacing_12} +
        ${props => props.theme.spacing.spacing_32}
    );
    gap: ${props => props.theme.spacing.spacing_16};
  }

  ${props => props.theme.breakpointsV2.smallDesktop} {
    text-wrap: balance; // fallback for pretty
    text-wrap: pretty;
    display: grid;
    grid-template-columns: repeat(auto-fit, 230px);
  }
`;

export const ListElement = styled(Text).attrs({
  as: "li",
  $style: {
    default: "medium_16",
    smallTablet: "medium_18",
  },
})`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: ${props => props.theme.spacing.spacing_8};
`;
